// extracted by mini-css-extract-plugin
export default {"wrapper":"cookie-page_wrapper__MVUt2","privacy":"cookie-page_privacy__ZFd1q","title":"cookie-page_title__Lk-SS","list":"cookie-page_list__PtfFI"};